module.exports = {
    "Clear search": `Obri\u{161}i pretragu`
};


//# sourceMappingURL=sr-SP.main.js.map
